/// <reference types="react" />

import React = require("react");
import ReactDOM = require("react-dom");
import Navigation_Services = require("VSS/Navigation/Services");

import Constants = require("DistributedTask/Scripts/Constants");
import Dialogs = require("DistributedTask/Scripts/Components/Dialogs");
import Menu = require("DistributedTask/Scripts/Common/Menu");
import Resources = require("DistributedTask/Scripts/Resources/TFS.Resources.DistributedTask");

import { LibraryItem } from "DistributedTask/Scripts/DT.LibraryItem.Model";
import { LibraryItemType } from "DistributedTask/Scripts/DT.Types";
import { contextualMenuIcon } from "VSSPreview/OfficeFabric/Helpers";
import { LibraryActionCreator } from "DistributedTask/Scripts/Actions/LibraryActionCreator";
import { IMenuItem, IMenuProps } from "VSSUI/Menu";

export class LibraryItemMenu {

    public getMenuItems(itemType: any, id: any, name: any, updateShowVariableGroupsDeleteDialogValue: any, updateShowSecureFilesDeleteDialogValue: any ): IMenuItem[] {
        if (itemType === LibraryItemType.VariableGroup) {
            return this.getVariableGroupMenuItems(itemType, id, name, updateShowVariableGroupsDeleteDialogValue);
        } else if (itemType === LibraryItemType.SecureFile) {
            return this.getSecureFileMenuItems(itemType, id, name, updateShowSecureFilesDeleteDialogValue);
        } else {
            return this.getLibraryMenuItems(itemType, id, name);
        }
    }

    private getLibraryMenuItems(itemType: any, id: any, name: any) {
        let childItems: IMenuItem[] = [];
        childItems.push({
            id: Constants.UserActions.ShowSecurityDialog,
            text: Resources.Security,
            important: true,
            iconProps: { iconName: "Shield" },
            onActivate: () => {
                Dialogs.Dialogs.showSecurityDialog(itemType, id, name);
            }
        })

        return childItems;
    }

    private getVariableGroupMenuItems(itemType: any, id: any, name: any, updateShowVariableGroupsDeleteDialogValue: any): IMenuItem[] {
        let childItems: IMenuItem[] = [];

        childItems.push({
            id: Constants.UserActions.EditLibraryItem,
            iconProps: { iconName: "Edit" },
            text: Resources.EditText,
            important: true,
            onActivate: () => {
                Navigation_Services.getHistoryService().addHistoryPoint(undefined, { view: Constants.LibraryConstants.VariableGroupView, variableGroupId: id });
            }
        });

        childItems.push({
            id: Constants.UserActions.DeleteLibraryItem,
            iconProps: { iconName: "Delete" },
            text: Resources.DeleteText,
            important: true,
            onActivate: () => {
                updateShowVariableGroupsDeleteDialogValue(true);
            }
        });

        childItems.push({
            id: Constants.UserActions.CloneLibraryItem,
            iconProps: { iconName: "Copy" },
            important: true,
            text: Resources.CloneText,
            onActivate: () => {
                LibraryActionCreator.getInstance().cloneVariableGroup(Number(id));
            }
        });

        childItems.push({
            id: Constants.UserActions.ShowSecurityDialog,
            iconProps: { iconName: "Shield" },
            important: true,
            text: Resources.Security,
            onActivate: () => {
                Dialogs.Dialogs.showSecurityDialog(itemType, id, name);
            }
        });

        return childItems;
    }

    private getSecureFileMenuItems(itemType: any, id: any, name: any, updateShowSecureFilesDeleteDialogValue: any) {
        let childItems: IMenuItem[] = [];

        childItems.push({
            id: Constants.UserActions.EditLibraryItem,
            iconProps: { iconName: "Edit" },
            important: true,
            text: Resources.EditText,
            onActivate: () => {
                Navigation_Services.getHistoryService().addHistoryPoint(undefined, { view: Constants.LibraryConstants.SecureFileView, secureFileId: id });
            }
        });

        childItems.push({
            id: Constants.UserActions.DeleteLibraryItem,
            iconProps: { iconName: "Delete" },
            important: true,
            text: Resources.DeleteText,
            onActivate: () => {
                updateShowSecureFilesDeleteDialogValue(true);
            }
        });

        childItems.push({
            id: Constants.UserActions.ShowSecurityDialog,
            iconProps: { iconName: "Shield" },
            important: true,
            text: Resources.Security,
            onActivate: () => {
                Dialogs.Dialogs.showSecurityDialog(itemType, id, name);
            }
        });

        return childItems;
    }
}
